import React from "react";
import {
  createSectorPath,
  LABEL_PADDING,
  MAX_LABEL_FONT_SIZE,
  polarToCartesian,
} from "./wheelMath";
import { useRaffleWheel } from "./RaffleWheelContext";
import cls from "./styles.module.scss";

export const WheelSectors = () => {
  const {
    center,
    currentParticipantIndex,
    radius,
    scale,
    sectors,
  } = useRaffleWheel();
  const labelRadius = radius - LABEL_PADDING;

  return (
    <g className={cls.sectors}>
      {sectors.map((sector, index) => {
        const labelPoint = polarToCartesian(sector.midAngle, labelRadius, center);
        const rotation = sector.midAngle - 90;
        const fontSize = Math.min(
          MAX_LABEL_FONT_SIZE * scale,
          sector.sectorAngle * 0.5 * scale
        );

        return (
          <g key={`${sector.participant.rank}-${sector.participant.name}`}>
            <path
              className={
                index === currentParticipantIndex
                  ? cls.meSector
                  : [cls.greenSector, cls.redSector, cls.goldSector][index % 3]
              }
              d={createSectorPath(
                sector.startAngle,
                sector.endAngle,
                radius,
                center
              )}
              filter="url(#sectorInnerShadow)"
            />
            <text
              className={cls.label}
              x={labelPoint.x}
              y={labelPoint.y}
              textAnchor="end"
              style={{ fontSize: `${fontSize}px` }}
              transform={`rotate(${rotation} ${labelPoint.x} ${labelPoint.y})`}
            >
              <tspan className={cls.labelLine} x={labelPoint.x} dy="0">
                {sector.participant.name}
              </tspan>
            </text>
          </g>
        );
      })}
    </g>
  );
};
